/**
 * Konstanten für das Rating Widget
 */

export const MAX_STARS = 5
export const STORAGE_KEY = 'userRatings'
export const RATING_ENDPOINT_TYPE = '1743405236'
export const FEEDBACK_TEXT_ENDPOINT_TYPE = '1743405237'
export const EMAIL_ENDPOINT_TYPE = '1743405238'
export const INTERACTION_DELAY_MS = 2000 // 2 Sekunden Verzögerung
export const FEEDBACK_DELAY_MS = 800 // 800ms Verzögerung vor dem Öffnen des Feedback-Modals
export const STATUS_AUTO_HIDE_DELAY_MS = 3000 // 3 Sekunden Auto-Hide für Statusmeldungen
